export const DND_3D_EFFECTS_SET = 'DND_3D_EFFECTS_SET';
